import { useUpdateEffect } from '@xing-com/crate-entity-pages-common';
import { useErrorContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-error-context';
import { IconShow } from '@xing-com/icons';

import { useEnableArticleMutation } from '../../../../hooks/use-enable-article-mutation';
import * as Styled from '../article-card-top.styles';

import type { ArticleControlButton } from './types';

export const ArticleShowButton: React.FC<ArticleControlButton> = ({
  article,
  disabled,
  onLoadingChange,
}) => {
  const { showError } = useErrorContext();

  const [handleEnableArticle, { loading }] = useEnableArticleMutation();

  useUpdateEffect(() => {
    onLoadingChange(loading);
  }, [loading]);

  const handleClick = async () => {
    try {
      await handleEnableArticle(article);
    } catch (error) {
      showError({ message: error.message, error });
    }
  };

  return (
    <Styled.Button
      data-testid={`ARTICLE-SHOW-BUTTON-${article.id}`}
      icon={IconShow}
      size="small"
      variant="tertiary"
      disabled={disabled}
      loading={loading}
      onClick={handleClick}
    />
  );
};
